import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Button,
    Typography,
    InputLabel,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from "../../context/Context";
import upload from "../../Admin/assets/images/upload-category.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const AddPopup = ({ openDialog, setOpenDialog, edit, setEdit, selectedEmployee, setEmployees }) => {
    const { loading, setLoading } = useGlobalContext()

    // Conditional dialog title and description
    const title = edit ? "Edit Employee" : "Add Employee";
    const description = edit
        ? "Update employee details."
        : "Add a new employee to the list.";

    //handle close
    const handleClose = () => {
        setOpenDialog(false);
        setEdit(false);

        if (edit && selectedEmployee) {
            // Set form data for edit
            setFormData({
                name: selectedEmployee?.employeeName || "",
                mobile: selectedEmployee?.employeeMobile || "",
                email: selectedEmployee?.employeeEmail || "",
                alt_mobile: selectedEmployee?.employeealtmobile || "",
                address: selectedEmployee?.employeeAddress || "",
                role: selectedEmployee?.employeeRole || "",
                profile_pic: null,
            });
        } else {
            // Reset form data and errors
            setFormData({
                name: "",
                mobile: "",
                email: "",
                alt_mobile: "",
                password: "",
                address: "",
                role: "",
                profile_pic: null,
            });
            setErrors({
                name: "",
                mobile: "",
                email: "",
                // alt_mobile: "",
                password: "",
                address: "",
                role: "",
                profile_pic: "",
            });
            setImagePreview('')
        }
    };

    const [errors, setErrors] = useState({
        name: "",
        mobile: "",
        email: "",
        // alt_mobile: "",
        password: "",
        address: "",
        role: "",
        profile_pic: "",
    });

    //formvalidation
    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Name validation
        if (formData.name.trim() === "") {
            newErrors.name = "Please enter a name";
            isValid = false;
        }

        // Mobile validation
        if (formData.mobile.trim() === "") {
            newErrors.mobile = "Mobile number is required";
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.mobile.trim())) {
            newErrors.mobile = "Mobile number must be 10 digits";
            isValid = false;
        }

        if (formData.alt_mobile.trim() !== "" && !/^\d{10}$/.test(formData.alt_mobile.trim())) {
            newErrors.alt_mobile = "Alternate mobile number must be 10 digits";
            isValid = false;
        }


        // Email validation
        if (formData.email.trim() === "") {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!/^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email.trim())) {
            newErrors.email = "Invalid email address";
            isValid = false;
        }

        // Alternate Mobile validation
        // if (formData.alt_mobile.trim() === "") {
        //     newErrors.alt_mobile = "Alternate mobile number is required";
        //     isValid = false;
        // } else if (!/^\d{10}$/.test(formData.alt_mobile.trim())) {
        //     newErrors.alt_mobile = "Alternate mobile number must be 10 digits";
        //     isValid = false;
        // }

        // Password validation
        if (formData.password.trim() === "") {
            newErrors.password = "Password is required";
            isValid = false;
        }
        // else if (formData.password.length < 6) {
        //     newErrors.password = "Password must be at least 6 characters";
        //     isValid = false;
        // }

        // Address validation
        if (formData.address.trim() === "") {
            newErrors.address = "Address is required";
            isValid = false;
        }

        // Role validation
        if (formData.role.trim() === "") {
            newErrors.role = "Role is required";
            isValid = false;
        }

        // Profile picture validation
        // if (!formData.profile_pic) {
        //     newErrors.profile_pic = "Profile picture is required";
        //     isValid = false;
        // }

        // Update the errors state
        setErrors(newErrors);

        return isValid;
    };


    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        alt_mobile: "",
        password: "",
        address: "",
        role: "",
        profile_pic: null,
    });

    const [imagePreview, setImagePreview] = useState(null); // Added for image preview

    useEffect(() => {

        if (edit && selectedEmployee) {
            // Set form data for edit
            setFormData({
                name: selectedEmployee?.employeeName || "",
                mobile: selectedEmployee?.employeeMobile || "",
                email: selectedEmployee?.employeeEmail || "",
                alt_mobile: selectedEmployee?.employeealtmobile || "",
                address: selectedEmployee?.employeeAddress || "",
                role: selectedEmployee?.employeeRole || "",
                profile_pic: null,
            });
        } else {
            // Reset form data for add
            setFormData({
                name: "",
                mobile: "",
                email: "",
                alt_mobile: "",
                password: "",
                address: "",
                role: "",
                profile_pic: null,
            });
            setImagePreview('')
        }
    }, [edit && selectedEmployee]);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;

        // Mobile number validation
        if (name === "mobile") {
            const onlyNums = value.replace(/[^0-9]/g, "");
            if (onlyNums.length <= 10) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    [name]: onlyNums,
                }));
            }
            // Always clear error for mobile dynamically
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
            return; // Exit early since we already handled mobile input
        }

        // Regular input or file
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: files ? files[0] : value,
        }));

        // Set image preview if it's a file input
        if (files && files[0]) {
            setImagePreview(URL.createObjectURL(files[0]));
        }

        // Clear the error dynamically for the field
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    //addemployee
    const handleAddEmployee = async () => {
        if (!validateForm()) {
            // If the form is not valid, don't proceed with the handleaddemployee
            return;
        }
        setLoading(true)
        try {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                data.append(key, value);
            });
            const response = await instance.post('/Admin/AdminSignup', data)

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setEmployees(true)
                setLoading(false)
            } else {
                toast.error(response.data.message)
                setLoading(false)
            }
        } catch (error) {
            const apiError = error?.response?.data;

            let displayMessage = apiError?.message || "Something went wrong";

            // If it's a duplicate key error, show a better message
            if (apiError?.error?.includes("duplicate key error")) {
                displayMessage = "Email already exists. Please use a different one.";
            }

            toast.error(displayMessage);
            setLoading(false);
        }
    }


    //updateemployee
    const handleUpdateEmployee = async () => {
        try {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                data.append(key, value);
            });

            const response = await instance.put(`/Admin/updateAdmin?user_id=${selectedEmployee.employeeId}`, data)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setEmployees(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            const apiError = error?.response?.data;

            let displayMessage = apiError?.message || "Something went wrong";

            // If it's a duplicate key error, show a better message
            if (apiError?.error?.includes("duplicate key error")) {
                displayMessage = "Email already exists. Please use a different one.";
            }

            toast.error(displayMessage);
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {title}
                    <Typography>{description}</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <hr style={{ margin: "10px 0px" }} />
                <DialogContent dividers>
                    <section className="add-employee">
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Full Name"
                                        label=" Full Name"
                                        type="text"
                                        fullWidth
                                        required
                                        name="name"
                                        size="small"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        error={!!errors.name}
                                    />
                                    <FormHelperText error={!!errors.name}>
                                        {errors.name}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter mobile number"
                                        label="Mobile Number"
                                        type="text"
                                        fullWidth
                                        required
                                        name="mobile"
                                        size="small"
                                        value={formData.mobile}
                                        onChange={handleInputChange}
                                        error={!!errors.mobile}
                                    />
                                    <FormHelperText error={!!errors.mobile}>
                                        {errors.mobile}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Email"
                                        label="Email"
                                        type="email"
                                        fullWidth
                                        required
                                        name="email"
                                        size="small"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        error={!!errors.email}
                                        disabled={selectedEmployee}
                                    />
                                    <FormHelperText error={!!errors.email}>
                                        {errors.email}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter alternate mobile"
                                        label="Alternate Mobile"
                                        type="text"
                                        fullWidth
                                        name="alt_mobile"
                                        size="small"
                                        value={formData.alt_mobile}
                                        onChange={handleInputChange}
                                        error={!!errors.alt_mobile}
                                    />
                                    <FormHelperText error={!!errors.alt_mobile}>
                                        {errors.alt_mobile}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            {!edit && (<Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Password"
                                        label="Password"
                                        type="text"
                                        fullWidth
                                        required
                                        name="password"
                                        size="small"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        error={!!errors.password}
                                    />
                                    <FormHelperText error={!!errors.password}>
                                        {errors.password}
                                    </FormHelperText>
                                </div>
                            </Grid>)}
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Area, Street, Sector, Village"
                                        label="Enter Address"
                                        type="text"
                                        fullWidth
                                        required
                                        name="address"
                                        size="small"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        error={!!errors.address}
                                    />
                                    <FormHelperText error={!!errors.address}>
                                        {errors.address}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className='admin-textfiled'>
                                    <FormControl fullWidth required>
                                        <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Select Role"
                                            required
                                            placeholder="Select Role"
                                            fullWidth
                                            name="role"
                                            value={formData.role}
                                            onChange={(e) =>
                                                handleInputChange({
                                                    target: {
                                                        name: "role",
                                                        value: e.target.value,
                                                    },
                                                })
                                            }
                                            error={!!errors.role}
                                        >
                                            <MenuItem value="JuniorDesigner">Junior Designer</MenuItem>
                                            <MenuItem value="SeniorDesigner"> Senior Designer</MenuItem>
                                            {/* <MenuItem value="Tailor">Tailor</MenuItem> */}
                                        </Select>
                                        <FormHelperText error={!!errors.role}>{errors.role}</FormHelperText>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                <div className='upload-image-preview'>
                                    <div className='file-upload-image'>
                                        <Typography variant='h5'>Employee image upload</Typography>
                                        <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                                            <img src={upload} alt="upload" />
                                        </label>
                                        <input
                                            id="file-upload"
                                            type="file"
                                            name="profile_pic"
                                            accept="image/*"
                                            multiple
                                            onChange={handleInputChange}
                                            style={{ display: "none" }} // Hide the input
                                        />
                                        {/* <FormHelperText error={!!errors.profile_pic}>
                                            {errors.profile_pic}
                                        </FormHelperText> */}
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                {imagePreview && (
                                    <div className="categoryimage-preview">
                                        <ul>
                                            <li>
                                                <img
                                                    src={imagePreview}
                                                    alt="Selected or Existing"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={edit ? handleUpdateEmployee : handleAddEmployee}
                        className="add-btn">
                        {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : edit ? 'Update' : 'Add'}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    );
};

export default AddPopup;
